import React from "react";
import ProjectsSection from "../components/ProjectsSection";
import styles from "./ProjectsPage.module.css";

const ProjectsPage: React.FC = () => {
  return (
    <main className={styles.page}>
      <ProjectsSection />
    </main>
  );
};

export default ProjectsPage;
